
import { EnumType, GetEnumdefType } from './types'
import { requestWy } from '@/utils/request'

export const getEnumdefApi = (params: GetEnumdefType): Promise<IResponse<EnumType[]>> => {
  return requestWy.get({ url: '/sys/dict/v2/enumdef', params })
}

export const getDictApi = (code: number): Promise<IResponse> => {
  return requestWy.get({ url: '/sys/dictinfo/infos/' + code })
}

export const getOpenCityListApi = (): Promise<IResponse> => {
  return requestWy.get({ url: '/sys/area/list/open' })
}
export const getMenuNavApi = (): Promise<IResponse> => {
  return requestWy.get({ url: '/sys/menu/nav' })
}
export const getUserInfoApi = (): Promise<IResponse> => {
  return requestWy.get({ url: '/sys/user/info' })
}

export const exportExcelApi = (method: string, url: string, data: any): Promise<IResponse> => {
  return requestWy[method]({ url, data, params: data })
}
